// extracted by mini-css-extract-plugin
module.exports = {"automateBtnWrapper":"automateButton_automateBtnWrapper_101eqRT","automateButton":"automateButton_automateButton_10U4frK","subText":"automateButton_subText__OanQgG"};